import { inject, observer } from "mobx-react";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { jobListGet } from "../../stores/request";
import { Chip, Container, TextField, Box } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";
import { Search } from "@mui/icons-material";
import { REQUEST } from "../../constants/status";
import { useNavigate } from "react-router";

const statusToProps = {
  等待运行: { color: "info", variant: "outlined" },
  正在运行: { color: "info" },
  failed: { color: "lightError" },
  success: { color: "lightSuccess" },
};

function getFullJobId({ row }) {
  return row.requestTime.slice(0, 10).split("-").join("") + row.jobId;
}
const parseDateTime = ({ value }) => (value === "not created" ? null : value); //new Date(value);
const renderDateTime = ({ value }) => (
  <Fragment>{value ? value.toLocaleString() : "not created"}</Fragment>
);

function JobHome(store) {
  useEffect(() => {
    getJobList();
  }, []);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchHelper, setSearchHelper] = useState("");
  const [result, setResult] = useState([]);

  useEffect(() => {
    setResult([...store.store.jobLists.data]);
  }, [store.store.jobLists.data]);

  const getJobList = async () => {
    let result = await jobListGet();
    if (result.success) {
      let dataCurrent = [];
      result.data.map((v, i, a) => {
        dataCurrent.push({
          key: v.jobId,
          jobId: v.jobId,
          requestTime: v.requestTime,
          createTime: v.createTime !== null ? v.createTime : "not created",
          completeTime:
            v.completeTime !== null ? v.completeTime : "not completed",
          status: [v.status],
        });
      });
      store.store.jobLists.request_success(dataCurrent);
      console.log(dataCurrent);
      // enqueueSnackbar("Get information successfully", { variant: "success" });
    } else {
      enqueueSnackbar("There is something in trouble", { variant: "error" });
    }
  };


  // DataGrid 列文档: https://mui.com/zh/components/data-grid/columns/
  const columns = useMemo(
    () => [
      {
        headerName: "Job Id", // 列头显示的文字
        field: "jobId", // 对应的源数据字段名
        valueGetter: getFullJobId, // 列数据的获取函数，会传入类似AntD的Record类型的参数params
        flex: 1,
        minWidth: 120,
      },
      {
        headerName: "Request Time",
        type: "dateTime",
        valueGetter: parseDateTime,
        field: "requestTime",
        flex: 1.5,
        minWidth: 170,
        renderCell: renderDateTime,
      },
      {
        headerName: "Create Time",
        type: "dateTime",
        valueGetter: parseDateTime,
        field: "createTime",
        flex: 1.5,
        minWidth: 170,
        renderCell: renderDateTime,
      },

      {
        headerName: "Complete Time",
        type: "dateTime",
        valueGetter: parseDateTime,
        field: "completeTime",
        flex: 1.5,
        minWidth: 170,
        renderCell: renderDateTime,
      },

      {
        headerName: "Status",
        field: "status",
        valueGetter: ({ value }) => {
          return value[0];
        },
        renderCell: (params) => (
          <Chip
            {...statusToProps[params.value]}
            label={params.value}
            sx={{ width: 1 }}
          />
        ), // 用于渲染单元格的函数，相当于AntD的render函数
      },
      {
        headerName: "Details",
        field: "actions",
        type: "actions",
        getActions: (param) => [
          <GridActionsCellItem
            icon={<Search />}
            label="Details"
            onClick={() => navigate("/result?jobId=" + getFullJobId(param))}
          />,
        ],
      },
    ],
    [navigate]
  );

  const onSearch = useCallback(async () => {
    if (searchValue.length < 8) {
      setSearchHelper("Please input right job id");
      return;
    }
    let indicator = false;
    const shortJobId = searchValue.slice(8);
    for (let i = 0; i < store.store.jobLists.data.length; i++) {
      if (shortJobId == store.store.jobLists.data[i].key) {
        indicator = true;
        break;
      }
    }
    if (indicator) {
      navigate("/result?jobId=" + searchValue);
    } else {
      setSearchHelper("Please input existing job id");
    }
    // console.log(store.store.jobLists.data[0].key);
    // setSearchHelper("");
    // let v_current = searchValue.slice(8);

    // console.log(v_current);
    // setSearchLoading(true);
    // store.store.results.request();
    // let result = await jobInfo(v_current);
    // console.log(result);
    // {
  });
  const handleKeyUp = (event) => {
    // console.log(event);
    if (event.keyCode === 13) {
      onSearch();
    }
  };

  //   train_positive: "1",
  //   train_negative: "胡彦斌",
  //   test_positive: 32,
  //   test_negative: "西湖区湖底公园1号",
  // }
  //   if (result.success) {
  //     setSearchLoading(false);
  //     // console.log()
  //     if (result.data.result.table_data) {
  //       if (result.data.result.table_data.best_performance) {
  //         let table_data = [];
  //         result.data.result.table_data.best_performance.map(
  //           (v, i, a) => {
  //             table_data.push({
  //               model_name: result.data.result.table_data.name[i],
  //               ACC: parseInt(v[0] * 100).toString() + "%",
  //               Sensitivity: parseInt(v[1] * 100).toString() + "%",
  //               Specificity: parseInt(v[2] * 100).toString() + "%",
  //               AUC: parseInt(v[3] * 100).toString() + "%",
  //               MCC: parseInt(v[4] * 100).toString() + "%",
  //             });
  //             console.log(table_data);
  //           }
  //         );

  //         result.data.result.table_data_performance = table_data;
  //       }

  //       if (result.data.result.table_data.data_statistic) {
  //         let table_data_datasets = [];

  //         table_data_datasets.push({
  //           train_positive:
  //             result.data.result.table_data.data_statistic[0],
  //           train_negative:
  //             result.data.result.table_data.data_statistic[1],
  //           test_positive:
  //             result.data.result.table_data.data_statistic[2],
  //           test_negative:
  //             result.data.result.table_data.data_statistic[3],
  //         });

  //         result.data.result.table_data_datasets = table_data_datasets;
  //       }

  //       if (result.data.result.table_data.time_use && result.data.result.table_data.name) {
  //         let time_use = { rowName: "Time Cost:" };

  //         result.data.result.table_data.time_use.map((v, i, a) => {
  //           time_use[result.data.result.table_data.name[i]] = v;
  //         });
  //         result.data.result.table_time_use = time_use;

  //         let time_use_title = [
  //           {
  //             title: "  ",
  //             dataIndex: "rowName",
  //             key: "rowName",
  //             className: "result-table-title",
  //           },
  //         ];
  //         result.data.result.table_data.time_use.map((v, i, a) => {
  //           time_use_title.push({
  //             title: result.data.result.table_data.name[i],
  //             dataIndex: result.data.result.table_data.name[i],
  //             key: result.data.result.table_data.name[i],
  //             className: "result-table-title",
  //           });
  //         });
  //         result.data.result.table_time_use_title = time_use_title;
  //       }
  //     }
  //     // let table_data = [];
  //     // result.data.result.table_data.best_performance.map((v, i, a) => {
  //     //   table_data.push({
  //     //     model_name: result.data.result.table_data.name[i],
  //     //     ACC: parseInt(v[0] * 100).toString() + "%",
  //     //     Sensitivity: parseInt(v[1] * 100).toString() + "%",
  //     //     Specificity: parseInt(v[2] * 100).toString() + "%",
  //     //     AUC: parseInt(v[3] * 100).toString() + "%",
  //     //     MCC: parseInt(v[4] * 100).toString() + "%",
  //     //   });
  //     //   console.log(table_data);
  //     // });
  //     // result.data.result.table_data_performance = table_data;
  //     store.store.results.request_success(result.data);
  //     store.store.servers.changeHomeStatue(7);

  //     // navigate("/result");
  //   } else {
  //     setSearchLoading(false);
  //     store.store.results.request_fail();
  //   }
  // }, [searchValue]);

  return (
    <Container
      maxWidth="xl"
      sx={{
        flex: 1,
        display: "flex",
        height: "100%",
        minHeight: 600,
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "left",
          paddingTop: 2,
          paddingBottom: 2,
          paddingLeft: 0,
          paddingRight: 0,
          ".MuiButton-root": { marginLeft: 1 },
        }}
      >
        <TextField
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          label="Input job id"
          helperText={searchHelper}
          onKeyUp={handleKeyUp}
          error={Boolean(searchHelper)}
          sx={{ flex: 1 }}
          size="small"
        />
        <LoadingButton
          loading={searchLoading}
          onClick={onSearch}
          loadingPosition="start"
          startIcon={<Search />}
          variant="contained"
          color="secondary"
        >
          Search
        </LoadingButton>
      </Box>
      <Box sx={{ flex: 1, marginBottom: 2 }}>
        <DataGrid
          rows={result}
          columns={columns}
          getRowId={(row) => row.jobId}
          loading={store.store.jobLists.status === REQUEST}
        />
      </Box>
    </Container>
  );
}

export default inject("store")(observer(JobHome));
